import { SecondaryText, StrongText } from '@dreryk/react-components';
import { createTranslatedText } from '@dreryk/react-common';

type NameCellProps = {
   name: string;
   description: string;
};

export const NameCell = (props: NameCellProps): JSX.Element => (
   <>
      <StrongText testId={'statisticsName'}>{props.name}</StrongText>
      {props.description ? (
         <SecondaryText testId={'statisticsDescription'} text={createTranslatedText(props.description)} />
      ) : null}
   </>
);
